import { authClient } from "@/lib/auth-client";

export function useSession() {
  const { data, isPending, error } = authClient.useSession();
  return {
    user: data?.user ?? null,
    session: data?.session ?? null,
    isLoading: isPending,
    error,
  };
}

export function useSignIn() {
  return async (email: string, password: string) => {
    const result = await authClient.signIn.email({ email, password });
    return result;
  };
}

export function useSignOut() {
  return async () => {
    await authClient.signOut();
    window.location.href = "/login";
  };
}
